module.exports = __webpack_public_path__ + "static/retroally-34433121855d0c694669846a40af3726.png";